<div class="flex flex-col w-full h-full">
  <!-- Título do gráfico -->
  <div class="text-gray-600 font-semibold mb-2 text-sm drop-shadow-sm">{{ title }}</div>
  
  <!-- Container principal do gráfico - ajustado para ocupar altura total -->
  <div class="flex-1 flex items-end justify-center gap-4 h-[calc(100%-40px)] relative pt-8">
    <!-- Grid de fundo - modificado para alinhar com as barras -->
    <div class="absolute inset-0 w-full h-full flex flex-col justify-between pt-8 pb-6">
      <!-- Linhas horizontais de grid com rótulos de valores reais -->
      <ng-container *ngFor="let value of gridValues; let i = index">
        <div class="relative">
          <div class="h-px w-full bg-gray-300"></div>
          <span class="absolute left-0 top-0 transform -translate-y-1/2 text-[9px] text-gray-600">{{ formatGridValue(value) }}</span>
        </div>
      </ng-container>
    </div>
    
    <!-- Iteração sobre os grupos -->
    <ng-container *ngFor="let group of data; let groupIndex = index">
      <div class="flex flex-col items-center justify-end h-full">
        <!-- Grupo de barras -->
        <div class="flex gap-0 mb-1 h-full">
          <!-- Barras para cada item no grupo -->
          <ng-container *ngFor="let item of group.items; let itemIndex = index">
            <div class="flex flex-col items-center relative w-10 h-full">
              <!-- Valor acima da barra - posicionado absolutamente -->
              <div class="text-xs font-bold absolute -top-6 left-1/2 -translate-x-1/2 z-10 text-gray-700 whitespace-nowrap drop-shadow-sm">
                {{ formatValue(item.value) }}
              </div>
              
              <!-- Barra vertical - modificada para garantir opacidade total -->
              <div 
                class="w-9 rounded-t-md transition-all duration-500 ease-in-out transform-gpu absolute bottom-0 shadow-md border-0"
                [ngClass]="getColorClass(itemIndex)"
                [ngStyle]="{ 'height': getBarHeight(item.value) }"
              ></div>
            </div>
          </ng-container>
        </div>
        
        <!-- Legenda do grupo -->
        <div class="text-xs truncate text-center w-full text-gray-600 mt-1 drop-shadow-sm">
          {{ group.label }}
        </div>
      </div>
    </ng-container>
  </div>
  
  <!-- Legenda das séries (se habilitada) -->
  <div *ngIf="showLegend && legendItems && legendItems.length > 0" 
       class="flex flex-wrap justify-center gap-3 mt-3 text-xs">
    <div *ngFor="let item of legendItems; let i = index" 
         class="flex items-center">
      <div [ngClass]="getColorClass(i)" class="w-3 h-3 rounded-sm mr-1 shadow-sm"></div>
      <span class="drop-shadow-sm">{{ item }}</span>
    </div>
  </div>
</div> 